import classNames from 'classnames';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import style from './style.module.scss';

interface Props {
  className?: string;
}

const LiveTag: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(style.liveTag, className)}>
      {t('component_live-tag_live', { defaultValue: 'Live' })}
    </div>
  );
};

LiveTag.displayName = 'LiveTag';

export default LiveTag;
